// extracted by mini-css-extract-plugin
export default {"wrap":"TJ-z","fullWidth":"UJ-z","hideOnDesktop":"VJ-z","content":"WJ-z","hasOpenedNav":"XJ-z","crumbsList":"YJ-z","dropdownsWrap":"ZJ-z"};